"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PasswordHideIcon = function PasswordHideIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5002 7C14.1452 7 16.2918 9.24 16.2918 12C16.2918 12.65 16.1672 13.26 15.9468 13.83L18.7452 16.75C20.1922 15.49 21.3327 13.86 22.0322 12C20.3743 7.61 16.2822 4.5 11.4906 4.5C10.1489 4.5 8.86475 4.75 7.67641 5.2L9.74641 7.36C10.2927 7.13 10.8772 7 11.5002 7ZM1.91683 4.27L4.10183 6.55L4.54266 7.01C2.95183 8.3 1.706 10.02 0.958496 12C2.61641 16.39 6.7085 19.5 11.5002 19.5C12.9856 19.5 14.4039 19.2 15.6977 18.66L16.1002 19.08L18.9081 22L20.1252 20.73L3.13391 3L1.91683 4.27ZM7.21641 9.8L8.70183 11.35C8.65391 11.56 8.62516 11.78 8.62516 12C8.62516 13.66 9.90933 15 11.5002 15C11.711 15 11.9218 14.97 12.1231 14.92L13.6085 16.47C12.9664 16.8 12.2572 17 11.5002 17C8.85516 17 6.7085 14.76 6.7085 12C6.7085 11.21 6.90016 10.47 7.21641 9.8ZM11.3468 9.02L14.3656 12.17L14.3847 12.01C14.3847 10.35 13.1006 9.01 11.5097 9.01L11.3468 9.02Z",
    fill: "black",
    fillOpacity: "0.54"
  }));
};

PasswordHideIcon.defaultProps = {
  width: '23',
  height: '24',
  viewBox: '0 0 23 24'
};
PasswordHideIcon.propTypes = {
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,

  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,

  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = PasswordHideIcon;
exports["default"] = _default;